import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta(
    "页面未找到 - 韩国妖精漫画角色图鉴",
    "你访问的页面不存在。返回萌妖图鉴首页，继续浏览韩国妖精漫画女主角色图鉴、萌娘属性与CP组合。"
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 py-24 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-emotion-unhappy-line text-3xl" aria-hidden="true"></i>
        </span>
        <h1 className="font-heading text-4xl font-bold text-foreground-950">404</h1>
        <p className="text-sm text-foreground-600">抱歉，你访问的页面不存在，可能这位女主还没被收录进来。</p>
        <div className="mt-4 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/encyclopedia"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-book-2-line" aria-hidden="true"></i>
            去角色图鉴
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}